import { SUCCESS_API_GET_SELECTABLE_REPORT_MEDIA } from '../actions/actionTypes';

export const appInitialState = {
  reports: [],
  totalNumber: 0,
  totalPages: 0,
  currentPage: 1,
  refreshPage: true,
  reportDetail: {},
  selectedReportId: '',
  editDetail: {},
  previewFileUrl: '',
  selectableReportMedia: {
    timelines: [],
    totalNumber: 0,
    totalPages: 0,
  },
};

const createFrames = frames =>
  (frames && frames.length > 0 && frames) || [
    { workRecord: {}, tags: [], note: '', updatedAt: '' },
  ];

export default function reducer(state = appInitialState, action) {
  switch (action.type) {
    case 'OPEN_REPORT':
    case 'RESET_REPORT_DETAILS': {
      const { editDetail, reportDetail, selectedReportId, previewFileUrl } =
        appInitialState;
      return {
        ...state,
        editDetail,
        reportDetail,
        selectedReportId,
        previewFileUrl,
      };
    }
    case 'SUCCESS_API_GET_REPORTS': {
      return {
        ...state,
        reports: action.payload.reports,
        totalNumber: action.payload.totalNumber,
        totalPages: action.payload.totalPages,
      };
    }
    case 'SUCCESS_API_CREATE_REPORT':
    case 'SUCCESS_API_GET_REPORT_DETAIL': {
      const {
        createdAt,
        frames,
        name,
        status,
        layoutType,
        id: reportId,
      } = action.payload;
      const editDetail = {
        ...state.editDetail,
        reportId,
        createDate: createdAt ?? '',
        frames: createFrames(frames),
        name,
        status,
        layoutType: layoutType ?? 1, // 現状は1固定
      };

      return {
        ...state,
        reportDetail: action.payload,
        editDetail,
        create: action.type === 'SUCCESS_API_CREATE_REPORT' ? true : undefined,
      };
    }
    /**
     * ステータス更新成功時にreportDetailのステータスを更新する
     */
    case 'SUCCESS_API_UPDATE_REPORT_STATUS': {
      return {
        ...state,
        reportDetail: {
          ...state.reportDetail,
          status: action.payload.status,
          lastUpdatedOperatorId: action.payload?.lastUpdatedOperatorId,
          lastUpdatedOperatorName: action.payload?.lastUpdatedOperatorName,
          updatedAt: action.payload.updatedAt,
          groupNo: action.payload.groupNo,
          reportNo: action.payload.reportNo,
        },
      };
    }
    /**
     * フレーム更新成功時にreportDetailの対象のフレーム情報を更新する
     */
    case 'SUCCESS_API_UPDATE_FRAME': {
      const newFrame = action.payload;

      return {
        ...state,
        reportDetail: {
          ...state.reportDetail,
          frames: state.reportDetail?.frames?.map(frame => {
            if (frame?.id === newFrame.id) {
              return newFrame;
            }
            return frame;
          }),
          updatedAt: newFrame.updatedAt,
        },
      };
    }
    case 'SUCCESS_API_DELETE_FRAME': {
      const { frameId, reportUpdatedAt } = action.payload;

      return {
        ...state,
        reportDetail: {
          ...state.reportDetail,
          frames: state.reportDetail?.frames?.filter(
            frame => frame.id !== frameId,
          ),
          updatedAt: reportUpdatedAt,
        },
      };
    }
    case 'SUCCESS_API_GET_REPORT_PREVIEW': {
      const { fileUrl: previewFileUrl } = action.payload;
      return { ...state, previewFileUrl };
    }
    case 'FAILED_API_GET_REPORT_PREVIEW': {
      return {
        ...state,
        reportDetail: { ...state.reportDetail, hasErrorPreview: true },
      };
    }
    case 'SELECT_REPORTS_PAGE': {
      const { page } = action;
      return {
        ...state,
        currentPage: page,
      };
    }
    case 'SET_REFRESH_PAGE_TRUE': {
      return {
        ...state,
        refreshPage: true,
      };
    }
    case 'SET_REFRESH_PAGE_FALSE': {
      return {
        ...state,
        refreshPage: false,
      };
    }
    case 'SELECT_REPORT': {
      return {
        ...state,
        selectedReportId: action.payload.selectedReportId,
      };
    }
    case 'OPEN_REPORT_EDIT_PAGE': {
      const { reportId } = action;
      const editDetail = { ...state.editDetail, reportId };
      return {
        ...state,
        editDetail,
        create: false,
        previewFileUrl: appInitialState.previewFileUrl,
      };
    }
    case 'UPDATE_REPORT_EDIT': {
      const { params } = action;
      const { editDetail } = state;
      return {
        ...state,
        editDetail: { ...editDetail, ...params },
      };
    }
    case SUCCESS_API_GET_SELECTABLE_REPORT_MEDIA: {
      const { timelines, totalNumber, totalPages } = action.payload;
      return {
        ...state,
        selectableReportMedia: {
          timelines,
          totalNumber,
          totalPages,
        },
      };
    }
    default:
      return state;
  }
}
